export const LOCALE = "en-US"
export const FORMAT_NUMBER_OPTS = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
}
